import * as React from "react";
import { BodyContext } from "../../../Common/Context/BodyContext";
import InfiniteLoader from "./InfiniteLoader";

/*
type Props = {
    onLoad          : () => Promise,
    loadingIndicator: React.Node,
    hasNextPage     : boolean,
};

export default class InfiniteLoading extends React.Component<Props> {
    static contextTypes = {
        body: PropTypes.object,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
        };

        this.handleScroll = debounce(100, false, this.handleScroll.bind(this));
        this.checkToLoad  = this.checkToLoad.bind(this);
        this.loadMoreData = this.loadMoreData.bind(this);
    }

    componentDidMount() {
        // Add the scroll event to the Body
        this.context.body.contentRef.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        // Remove the scroll event from the Window
        this.context.body.contentRef.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        if(this.state.loading === true) return;

        this.checkToLoad();
    }

    checkToLoad() {
        if (!this.props.hasNextPage) {
            return;
        }

        const position = this.context.body.contentRef.scrollTop + document.body.scrollHeight - 50;
        const height   = this.context.body.contentRef.scrollHeight;

        if(height - position <= 200) {
            // Load more data
            this.loadMoreData();
        }
    }

    loadMoreData() {
        this.setState({
            loading: true,
        });

        return this.props.onLoad().then(() => {
            this.setState({
                loading: false,
            });
        });
    }

    render() {
        // Render the children
        if(this.state.loading) {
            return (
                <React.Fragment>
                    {this.props.children}
                    {this.props.loadingIndicator}
                </React.Fragment>
            );
        }

        return this.props.children;
    }
}
*/

type Props = {
    onLoad: () => Promise<void>;
    loadingIndicator: React.ReactNode;
    hasNextPage: boolean;
    children: React.ReactNode;
    innerRef?: React.Ref<InfiniteLoader>;
};

export class InfiniteLoading extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <BodyContext.Consumer>
                {(body): React.ReactNode => {
                    let el;

                    if(!body.current) {
                        el = document.body;
                    } else {
                        el = body.current;
                    }

                    return (
                        <InfiniteLoader
                            ref={this.props.innerRef}
                            onLoad={this.props.onLoad}
                            loadingIndicator={this.props.loadingIndicator}
                            hasNextPage={this.props.hasNextPage}
                            topPadding={document.body.scrollHeight - 50}
                            loadingThreshold={400}
                            element={el}
                        >
                            {this.props.children}
                        </InfiniteLoader>
                    );
                }}
            </BodyContext.Consumer>
        );
    }
}

export default React.forwardRef((props: Props, ref: React.Ref<InfiniteLoader>) => (
    <InfiniteLoading {...props} innerRef={ref} />
));
